import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Container,
  Typography,
  Button,
  Card,
  CardContent,
  Box,
} from "@mui/material";
import axios from "axios";
import { UserContext } from "../context/UserContext";
import API_BASE_URL from "../config";

const ClassifiedsPageDetails = () => {
  const { user } = useContext(UserContext);
  const { id } = useParams();
  const [classified, setClassified] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchClassified = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/classifieds/${id}`
        );
        console.log("Fetching classified with ID:", id);
        const data = await response.json();
        console.log("Fetched classified data:", data);
        setClassified(Array.isArray(data) ? data[0] : data);
      } catch (err) {
        console.error("Error fetching classified:", err);
      }
    };

    fetchClassified();
  }, [id]);

  if (!classified) {
    return <Typography>Loading...</Typography>;
  }

  const handleShowInterest = async () => {
    if (!classified || !user) return;

    const user_id = user.id;
    const opportunity_provider_id = classified.user_id;
    const opportunity_id = classified.id;
    const user_name = user.name;
    const opportunity_name = classified.title; // ✅ Fixed this line

    try {
      await axios.post(`${API_BASE_URL}/classifieds/show-interest`, {
        user_id,
        opportunity_provider_id,
        opportunity_id,
        user_name,
        opportunity_name,
      });
      alert("Your interest has been sent!");
    } catch (err) {
      console.error("Error sending interest:", err);
      alert("Failed to send interest. Please try again later.");
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 5,mb:4 }}>
      <Card sx={{ p: 3, boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h4" color="#42326e" fontWeight="bold">
            {classified.title}
          </Typography>

          <Box display="flex" alignItems="center" mt={1}>
            <Typography variant="body1">
              <strong> ₹{classified.price}</strong>
            </Typography>
          </Box>

          <Box display="flex" alignItems="center">
            <Typography variant="body2">{classified.category}</Typography>
          </Box>

          <Typography sx={{ fontSize: "1rem", mt: 2 }}>
            {classified.description}
          </Typography>

          <Button
            variant="contained"
            color="success"
            sx={{ mt: 3, width: "40%" }}
            onClick={handleShowInterest}
          >
            Show Interest
          </Button>
        </CardContent>
      </Card>
    </Container>
  );
};

export default ClassifiedsPageDetails;
